module.exports = __webpack_public_path__ + "static/img/GL-6-A智能安全帽使用说明书-4.c348358.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/GL-6-A智能安全帽使用说明书-4.jpg
// module id = IXyz
// module chunks = 0